import bugsnag from 'bugsnag-js';
import BugsnagErrorHandler from 'bugsnag-angular';

export interface Config {
    token: string;
    enabled: boolean;
}

/**
 * Create a new Bugsnag error handler.
 *
 * @constructor
 *
 * @param config
 */
export function ErrorHandlerFactory(config: Config) {
    return new BugsnagErrorHandler(
        bugsnag(config.token)
    );
}


// WEBPACK FOOTER //
// ./libs/bugsnag/src/error-handler.factory.ts